import * as React from "react";
import { ICellRendererParams } from "ag-grid-community";
import { formatMessage } from "lib/globalize-util";

const yesNoValueFormatter = (value: any) => {
    if (typeof value === "boolean") {
        return value ? formatMessage("Yes") : formatMessage("No");
    }

    return value;
};

interface IProps extends ICellRendererParams {}
const YesNoCellRenderer: React.FC<IProps> = ({ value }) => {
    return yesNoValueFormatter(value);
};

export { YesNoCellRenderer, yesNoValueFormatter };
